import { FormSubmitHack } from "common/FormSubmitHack";
import { CircleSpinner } from "common/spinners/CircleSpinner";
import { CTA } from "common/styleguide/CTA";
import { DatePickerInput } from "common/styleguide/DatePickerInput";
import { ModalOverlay } from "common/styleguide/ModalOverlay";
import { Event } from "data/records";
import { commonNouns, commonVerbs, Msg } from "lib/localization";
import { errorMessage } from "lib/styleguide/base.scss";
import { urls } from "lib/urls";
import moment from "moment";
import p from "prop-types";
import React from "react";
import { FormattedMessage as T, injectIntl } from "react-intl";

export const CREATE_EVENT_DIALOG = "CREATE_EVENT_DIALOG";

class _CreateEvent extends React.PureComponent {
  static propTypes = {
    onSubmit: p.func.isRequired,
    onRequestClose: p.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      name: "",
      date: undefined,
      createPending: false,
      createError: false,
      message: null,
    };
  }

  onSubmit = (e) => {
    e.preventDefault();

    const { onSubmit } = this.props;
    const { name, date } = this.state;
    // NOTE: including startsAt here because nil starts_at in request will unset starts_on -> unscheduled event
    const params = {
      name: name,
      startsOn: date && moment(date),
      startsAt: date && moment(date).startOf("day"),
    };

    if (name === "") {
      this.setState({ createError: true, message: "Please provide a name" });
    } else {
      this.setState({ createPending: true });
      onSubmit(new Event(params))
        .then((r) => {
          window.location.href = urls.events.show(r.action.payload.result.slug);
        })
        .catch((r) =>
          this.setState({
            createPending: false,
            createError: true,
            message: r.message && JSON.parse(r.message)[0].error_message,
          })
        );
    }
  };

  onNameChange = (e) => {
    const name = e.target.value;
    this.setState({ name });
  };

  onDateChange = (date) => {
    this.setState({ date });
  };

  render() {
    const { onRequestClose } = this.props;
    const { name, date, createPending, createError, message } = this.state;

    return (
      <ModalOverlay
        title={<T id="createEventDialog.createAnEvent" defaultMessage="Create an event" />}
        maxWidth="380px"
        onRequestClose={onRequestClose}
      >
        {createError && (
          <div className={errorMessage}>
            {!message ? (
              <T
                id="createEventDialog.error"
                defaultMessage="Oops, we encountered an error while creating your event. Please try again."
              />
            ) : (
              message
            )}
          </div>
        )}

        <p>
          <T id="createEventDialog.enterName" defaultMessage="Enter the name of your event to get started." />
        </p>

        <form onSubmit={this.onSubmit}>
          <FormSubmitHack />
          <div>
            <label>
              <Msg capitalized m={commonNouns.name} />
            </label>
            <input autoFocus type="text" value={name} onChange={this.onNameChange} />
          </div>

          <div>
            <label>
              <T id="createEventDialog.whenIsIt" defaultMessage="When is it?" />
            </label>
            <DatePickerInput allowBlank date={date} onDateChange={this.onDateChange} />
          </div>
          <CTA button type="submit" disabled={createPending} onClick={this.onSubmit}>
            {createPending ? (
              <CircleSpinner light size={12} />
            ) : (
              <T id="createEventDialog.create" defaultMessage="Create Event" />
            )}
          </CTA>
          <CTA link margins={false} onClick={onRequestClose}>
            <Msg capitalized m={commonVerbs.cancel} />
          </CTA>
        </form>
      </ModalOverlay>
    );
  }
}

export const CreateEvent = injectIntl(_CreateEvent);
